import { getTicketEarnRate } from "../../../app/api/getCachedTiersConfig";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IEarnPointsCheckoutRequest } from "../../../Orchestrator/Types/Interface/ActionParams/EarnPointsActionParams";

class GetEarnPointsCheckoutAction extends BaseAction<void, IEarnPointsCheckoutRequest> {
    override async run(): Promise<void> {
        try {
            let addonsTotalShouldAdd = 0;
            const { meal, addonsPassengerList } = this.params!;

            // Fetch ticket earn rate (points per AED), session-cached via getCachedTiersConfig
            let ticketEarnRate = 1;
            try {
                ticketEarnRate = await getTicketEarnRate();
            } catch {
                console.warn("[GetEarnPointsCheckoutAction] Failed to fetch ticket earn rate, falling back to 1 pt/AED");
            }

            if (meal && typeof meal === 'object') {
                for (const [legId, legData] of Object.entries(meal)) {
                    const passengerCount = addonsPassengerList?.find(
                        (leg) => leg.legId === legId
                    )?.addonsPassenger?.length ?? 1;
                    for (const items of Object.values(legData)) {
                        if (Array.isArray(items) && items.length) {
                            const highestPrice = Math.max(...items.map(i => i.price));
                            addonsTotalShouldAdd += highestPrice * passengerCount;
                        }
                    }
                }
                updateRecoilState<number>("earnExtraPointsAtom", ticketEarnRate * addonsTotalShouldAdd);
            }
        }

        catch (error: any | null) {
            console.error("Error in GetEarnPointsCheckoutAction:", error);
        }
    }
}

export const getEarnPointsCheckoutAction = new GetEarnPointsCheckoutAction();
